import React from 'react';
import { ArrowRight, Star, BookOpen, Users, Compass } from 'lucide-react';
export function OfertaRise() {
  return <div className="bg-rise-white min-h-screen pb-20" data-id="element-844" data-mp="1630t9jh71ucq">
      {/* Hero Section - reduced top spacing */}
      <section className="pt-4 pb-8 md:pt-6 md:pb-12 px-6 text-center" data-id="element-845" data-mp="1krn5hcbiy5zq">
        <div className="max-w-rise-content mx-auto flex justify-center" data-id="element-846" data-mp="1ftbx760vo3jm">
          {/* Text Content */}
          <div className="flex flex-col items-center text-center max-w-3xl" data-id="element-847" data-mp="s3hjyncnccyu">
            <div className="inline-block font-dm-sans text-[13px] tracking-[0.15em] uppercase text-rise-black border border-rise-gold/50 rounded-full px-5 py-2 mb-6" data-id="element-848" data-mp="n5g0i1bb6bmu">
              <span className="flex items-center gap-2" data-id="element-849" data-mp="120dueym3v961">
                <Star size={14} className="text-rise-gold" data-id="element-850" data-mp="x345dk2moziq" />
                CURSURI & PROGRAME
              </span>
            </div>
            <h1 className="font-playfair text-[36px] md:text-[52px] leading-tight text-rise-black mb-6" data-id="element-851" data-mp="2dfsre2ebe115">
              Alege parcursul tău
            </h1>
            <p className="font-dm-sans text-[19px] text-rise-gray max-w-xl mx-auto leading-relaxed" data-id="element-852" data-mp="30j9btxqudof3">
              De la primul pas spre liniștea interioară până la transformarea
              profundă prin abundență, iubire și prezență. Toate programele și
              sesiunile R.I.S.E. într-un singur loc.
            </p>
          </div>
        </div>
      </section>

      {/* Products Grid */}
      <section className="px-6 pb-20" data-id="element-853" data-mp="2hsrlu0xe96xf">
        <div className="max-w-rise-content mx-auto grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-854" data-mp="2htt9r5zidnwk">
          {/* Card 1: 1:1 Coaching (Highlighted) */}
          <div className="bg-white border-2 border-rise-gold rounded-2xl overflow-hidden flex flex-col shadow-lg relative transform md:-translate-y-4" data-id="element-855" data-mp="2qswsu9yoe3b2">
            <div className="absolute top-4 right-4 z-10 bg-rise-gold text-rise-black text-[12px] font-bold uppercase tracking-wider px-3 py-1 rounded-full flex items-center gap-1" data-id="element-856" data-mp="2vkoatw3rn0pl">
              <Star size={12} data-id="element-857" data-mp="231rddvwndd1a" />
              RECOMANDAT
            </div>
            <div className="h-40 bg-rise-black relative overflow-hidden flex items-center justify-center" data-id="element-858" data-mp="36dgeep9dmife">
              <Compass size={80} className="text-rise-gold" strokeWidth={1.2} data-id="element-859" data-mp="31fohthxse84v" />
              <div className="absolute bottom-4 left-4 bg-rise-gold text-rise-black text-[13px] font-semibold px-3 py-1 rounded-full flex items-center gap-1.5" data-id="element-860" data-mp="3g3jbp1nj6ijj">
                <Users size={14} data-id="element-861" data-mp="3b6syqn70w32c" />
                Sesiuni 1:1
              </div>
            </div>
            <div className="p-8 flex flex-col flex-grow" data-id="element-862" data-mp="2nh83p5xlhfcp">
              <div className="text-rise-gold uppercase tracking-wider text-[12px] font-bold mb-2" data-id="element-863" data-mp="2ih2jubxkgx56">
                TRANSFORMARE PROFUNDĂ
              </div>
              <h3 className="font-playfair text-[26px] text-rise-black mb-2" data-id="element-864" data-mp="2se89dfqj8g3a">
                Coaching 1 la 1
              </h3>
              <p className="font-dm-sans text-[15px] italic text-rise-gray mb-6" data-id="element-865" data-mp="botczeut5d6c">
                Ghidare personalizată pentru evoluția ta
              </p>

              <div className="mb-6 inline-flex items-center gap-2 self-start bg-rise-gold/10 text-rise-black border border-rise-gold/40 rounded-full px-4 py-2 font-dm-sans text-[14px] font-semibold uppercase tracking-wider" data-id="element-866" data-mp="7q2g98u97xjr">
                <Star size={14} className="text-rise-gold" data-id="element-867" data-mp="59krmqezqz3z" />
                Pe bază de aplicație
              </div>

              <p className="font-dm-sans text-[16px] text-rise-gray mb-8 flex-grow" data-id="element-868" data-mp="a7mb3cgbx0fz">
                Sesiuni individuale adaptate nevoilor tale specifice. Lucrăm
                împreună pentru a depăși blocajele, a clarifica direcția și a
                construi o viață aliniată cu adevărata ta identitate.
              </p>

              <a href="https://comunitatearise.ro/coaching1la1" target="_top" className="bg-rise-gold text-rise-black hover:bg-rise-gold-light px-6 py-4 rounded-xl font-dm-sans font-semibold text-[15px] transition-colors text-center flex items-center justify-center gap-2 w-full" data-id="element-869" data-mp="o7nkxhekni7l">
                Află mai multe <ArrowRight size={18} data-id="element-870" data-mp="3u56n9j71m71x" />
              </a>
            </div>
          </div>

          {/* Card 2: Community */}
          <div className="bg-white border border-gray-200 rounded-2xl overflow-hidden flex flex-col shadow-sm" data-id="element-871" data-mp="3p4r9wrmrgzjy">
            <div className="h-40 bg-rise-black relative overflow-hidden flex items-center justify-center" data-id="element-872" data-mp="3k6zg1s2k33d4">
              <Users size={80} className="text-rise-gold" strokeWidth={1.2} data-id="element-873" data-mp="3f97es7g0u4w9" />
              <div className="absolute bottom-4 left-4 bg-rise-gold text-rise-black text-[13px] font-semibold px-3 py-1 rounded-full flex items-center gap-1.5" data-id="element-874" data-mp="gofpctzj05kf">
                <Users size={14} data-id="element-875" data-mp="6znxelugtl9i" />
                Abonament Lunar
              </div>
            </div>
            <div className="p-8 flex flex-col flex-grow" data-id="element-876" data-mp="21e3sfoe2sq0">
              <div className="text-rise-gray uppercase tracking-wider text-[12px] font-bold mb-2" data-id="element-877" data-mp="1yrykmoz0pay">
                CONEXIUNE & CREȘTERE
              </div>
              <h3 className="font-playfair text-[26px] text-rise-black mb-2" data-id="element-878" data-mp="upa19mls8onu">
                Comunitatea R.I.S.E.
              </h3>
              <p className="font-dm-sans text-[15px] italic text-rise-gray mb-6" data-id="element-879" data-mp="12zz4hf7t52b7">
                Spațiul tău de siguranță și evoluție
              </p>

              <div className="mb-6 inline-flex items-center gap-3 self-start bg-rise-gold/10 text-rise-black border border-rise-gold/40 rounded-full px-4 py-2 font-dm-sans text-[14px] font-semibold" data-id="element-880" data-mp="1byb2w3ex14e7">
                <span className="line-through text-rise-gray/70" data-id="element-881" data-mp="1lxtn8kyqms6s">249 RON</span>
                <span className="text-rise-gold uppercase tracking-wider" data-id="element-882" data-mp="1pydkdojb9vsx">
                  49 RON / lună
                </span>
              </div>

              <p className="font-dm-sans text-[16px] text-rise-gray mb-8 flex-grow" data-id="element-883" data-mp="1upvm4et5s0ey">
                Acces la întâlniri de grup, meditații ghidate, resurse exclusive
                și o rețea de oameni care împărtășesc aceleași valori. Creștem
                împreună, pas cu pas.
              </p>

              <a href="https://comunitatearise.ro/comunitaterise" target="_top" className="bg-rise-gold text-rise-black hover:bg-rise-gold-light px-6 py-4 rounded-xl font-dm-sans font-semibold text-[15px] transition-colors text-center flex items-center justify-center gap-2 w-full" data-id="element-884" data-mp="29n4e9aqad87q">
                Vreau în Comunitate <ArrowRight size={18} data-id="element-885" data-mp="1oxa9cq69o6d8" />
              </a>
            </div>
          </div>

          {/* Card 3: Program */}
          <div className="bg-white border border-gray-200 rounded-2xl overflow-hidden flex flex-col shadow-sm" data-id="element-886" data-mp="22nnl73ma457u">
            <div className="h-40 bg-rise-black relative overflow-hidden flex items-center justify-center" data-id="element-887" data-mp="1xpm0ke97fxu9">
              <BookOpen size={80} className="text-rise-gold" strokeWidth={1.2} data-id="element-888" data-mp="2cl1y4t8zubve" />
              <div className="absolute bottom-4 left-4 bg-rise-gold text-rise-black text-[13px] font-semibold px-3 py-1 rounded-full flex items-center gap-1.5" data-id="element-889" data-mp="i8lkh7dvbvgi">
                <BookOpen size={14} data-id="element-890" data-mp="dc3ey5aprt34" />
                Program 12 Săptămâni
              </div>
            </div>
            <div className="p-8 flex flex-col flex-grow" data-id="element-891" data-mp="2twgyptzxgnyl">
              <div className="text-rise-gray uppercase tracking-wider text-[12px] font-bold mb-2" data-id="element-892" data-mp="2tvxfm9yjjtiz">
                FUNDAȚIE SOLIDĂ
              </div>
              <h3 className="font-playfair text-[26px] text-rise-black mb-2" data-id="element-893" data-mp="2k6dv6zv6jrm0">
                Programul R.I.S.E.
              </h3>
              <p className="font-dm-sans text-[15px] italic text-rise-gray mb-6" data-id="element-894" data-mp="265tb80dj3pqx">
                Realitate • Identitate • Stabilitate • Evoluție
              </p>

              <div className="mb-6 inline-flex items-center gap-3 self-start bg-rise-gold/10 text-rise-black border border-rise-gold/40 rounded-full px-4 py-2 font-dm-sans text-[14px] font-semibold" data-id="element-895" data-mp="1w8yenn0tfzfa">
                <span className="line-through text-rise-gray/70" data-id="element-896" data-mp="3qmzd46sgekeu">1200 RON</span>
                <span className="text-rise-gold uppercase tracking-wider" data-id="element-897" data-mp="3qkwqlwqif9ev">
                  699 RON
                </span>
              </div>

              <p className="font-dm-sans text-[16px] text-rise-gray mb-8 flex-grow" data-id="element-898" data-mp="2if7qf1bimgj5">
                Un parcurs structurat de 12 săptămâni pentru a-ți reconstrui
                fundația interioară. Module video, exerciții practice și suport
                continuu pentru o transformare de durată.
              </p>

              <a href="https://comunitatearise.ro/programulrise" target="_top" className="bg-rise-gold text-rise-black hover:bg-rise-gold-light px-6 py-4 rounded-xl font-dm-sans font-semibold text-[15px] transition-colors text-center flex items-center justify-center gap-2 w-full" data-id="element-899" data-mp="24mro62qfumja">
                Descoperă Programul <ArrowRight size={18} data-id="element-900" data-mp="1lp8d6tkf6tu8" />
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Consultanta Banner - centered text + button below */}
      <section className="px-6 pb-20" data-id="element-901" data-mp="3g2q3upg4g6th">
        <div className="max-w-rise-content mx-auto" data-id="element-902" data-mp="3g419yvx1hqnr">
          <div className="bg-gradient-to-br from-rise-anthracite to-rise-black rounded-3xl p-10 md:p-16 flex flex-col items-center justify-center text-center gap-6 border border-rise-gold/20 relative overflow-hidden" data-id="element-903" data-mp="3nm8u9grp32c3">
            {/* Subtle background glow */}
            <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-904" data-mp="1767ov2vgd4s">
              <div className="absolute -top-[50%] left-1/2 -translate-x-1/2 w-[80%] h-[200%] bg-rise-gold/5 blur-[120px] rounded-full" data-id="element-905" data-mp="64y0rsf965ak"></div>
            </div>

            <div className="relative z-10 flex flex-col items-center" data-id="element-906" data-mp="39locmnxinck6">
              <div className="inline-flex items-center gap-2 text-rise-gold text-[12px] font-bold uppercase tracking-wider bg-rise-gold/10 px-4 py-1.5 rounded-full mb-6" data-id="element-907" data-mp="3elkiksprxe2d">
                <span className="w-2 h-2 rounded-full bg-rise-gold animate-pulse" data-id="element-908" data-mp="3ioh1kkj87c6u"></span>
                20 DE MINUTE • CADOU
              </div>
              <h2 className="font-playfair text-[32px] md:text-[42px] text-rise-white mb-4" data-id="element-909" data-mp="xwdwcbysf2cx">
                Nu știi ce să alegi?
              </h2>
              <p className="font-dm-sans text-[18px] text-rise-white/80 max-w-2xl leading-relaxed mb-8" data-id="element-910" data-mp="27k2ygjbzachr">
                Rezervă o sesiune de consultanță cadou de 20 de minute. Vorbim
                despre unde te afli acum, ce îți dorești și ce parcurs ți se
                potrivește cel mai bine.
              </p>

              <a href="https://docs.google.com/forms/d/e/1FAIpQLSfZvTY3b9zlXihtr5N7rytBUsvVV4lTYHjzoiEOGqKUeKSdVw/viewform" target="_top" className="bg-rise-gold text-rise-black hover:bg-rise-gold-light px-8 py-4 rounded-xl font-dm-sans font-semibold text-[16px] transition-colors inline-flex items-center justify-center gap-2" data-id="element-911" data-mp="2mb3fhcqsjepi">
                Rezervă Sesiunea <ArrowRight size={18} data-id="element-912" data-mp="39ytpzgsv0cbl" />
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>;
}